import { Form, Input, ModalProps, FormProps, Modal, InputNumber, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'

type EditSubjectProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const EditSubject: React.FC<EditSubjectProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values?.code?.trim()) {
      values.name = values?.name?.trim()
      const isNameStillSame = values?.name === formProps?.initialValues?.name
      if (!isNameStillSame) {
        const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'subjects')
        if (isNameRepeated && isNameRepeated?.subjects?.length > 0) {
          message.error('Subject name is already present... please make sure subjects are unique')
          return false
        }
        return (
          formProps.onFinish &&
          formProps.onFinish({
            ...values,
            updated_by: user?.id,
          })
        )
      }
     
    } else {
      message.error('Expected values are missing...')
    }
  }
  return (
    <Modal {...modalProps} title="Edit Subject">
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('subjects', 'edit', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Subject Code"
          name="code"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Subject Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
